import { render, staticRenderFns } from "./bottom-flop.vue?vue&type=template&id=bb0b0388&"
import script from "./bottom-flop.vue?vue&type=script&lang=js&"
export * from "./bottom-flop.vue?vue&type=script&lang=js&"
import style0 from "./bottom-flop.vue?vue&type=style&index=0&id=bb0b0388&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports